var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"modal-sizeguide","width":620}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    Size Guide\n  ")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('SizeGuideContent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }